import { gql } from "@apollo/client"

export const GET_EPS_BY_CITY = gql`
  query getEpsByCity($cityId: String!) {
    getEpsByCity(cityId: $cityId) {
      message
      data {
        eps {
          name
          id
        }
      }
    }
  }
`
